
import { Component, Emit, Prop, Mixins } from "vue-property-decorator"
import api from "../../honcierge-api"
import ProcessingMixin from "../../mixins/processing-mixin"
import { Curator } from "types/curator"

@Component
export default class CuratorSearchForm extends Mixins(ProcessingMixin) {
  @Prop({ default: true })
  private enableName!: boolean

  private name = ""
  private result: Curator["view"][] = []

  @Emit("resetPagination")
  public emitResetPagination(): void {
    /* */
  }
  @Emit("resetSelection")
  public emitResetSelection(): void {
    /* */
  }
  @Emit("searchResult")
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private searchResult(result: Curator["view"][], totalPages: number) {
    /* */
  }

  public reset() {
    this.name = ""
    this.result.length = 0
  }

  public async search(page = 1, sortBy = "id", descending = false) {
    this.startProcess()
    try {
      const response = await api.getCurators({
        name: this.name,
        page,
        per: 10,
        sortBy,
        descending,
      })
      this.result = response.data.curators
      this.searchResult(
        response.data.curators.length > 0 ? this.result : [],
        response.data.meta.totalPages
      )
    } catch {
      this.$toasted.error("著名人情報の取得に失敗しました")
    } finally {
      this.endProcess()
    }
  }
}
